import React from 'react';
import './styles.css'
import PropTypes from 'prop-types';


//csv tooltip imports
import Tooltip from '@material-ui/core/Tooltip';
import InfoIcon from '@material-ui/icons/Info';
import { withStyles } from '@material-ui/core/styles';



const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        padding: '5px',
        fontSize: 15,
        marginTop: -10
    },
}))(Tooltip);


function CSVTooltip(props) {

    //to decide which sample file to be downloaded.
    //Currently the same file is acceptable for both situations.
    const filetype = props.filetype;

    const downloadStudentsFile = () => {
        window.open("https://umt-dev-stageing1.s3.ap-south-1.amazonaws.com/NewStudentDetails.csv");
    }

    const downloadTeachersFile = () => {
        window.open("https://umt-dev-stageing1.s3.ap-south-1.amazonaws.com/NewTeacherDetails.csv");
    }

    return (
        <LightTooltip title={
            <React.Fragment>
                <div className="custom_csvtooltip">
                    <mark onClick={(filetype == 'students') ? downloadStudentsFile : downloadTeachersFile}>Click</mark> for a sample csv file.
                </div>
            </React.Fragment>
        } interactive>
            <span {...props}><InfoIcon style={{ fontSize: 15, margin: '5px', cursor: 'help' }} /></span>
        </LightTooltip>
    );
}

CSVTooltip.propTypes = {
    filetype: PropTypes.string.isRequired
};

export { CSVTooltip };